import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { ManufacturerService } from "src/app/services/manufacturer.service";

@Component({
  selector: "app-userfbtimeline",
  templateUrl: "./userfbtimeline.component.html",
  styleUrls: ["./userfbtimeline.component.scss"],
})
export class UserfbTimelineComponent implements OnInit {
  userfbTimeLineList: any[];
  color: string;
  id: any;
  routeParams: any;

  constructor(private manufacturerService: ManufacturerService,
    route: ActivatedRoute) {
    this.routeParams = route.snapshot.params;
    this.id = this.routeParams.id;
  }

  ngOnInit(): void {
    this.getmanufacturerTimeLine(true);
  }

  approvedStatusColor(statusType: number) {
    switch (statusType) {
      case 1:
        return '#10B759'
      case 2:
        return '#800080'
      case 3:
        return '#D80F0F'
      case 4:
        return '#3F67A7'
      case 5:
        return '#F74040'
        
    }
  }

  getmanufacturerTimeLine(refresh: boolean) {
    this.userfbTimeLineList = [];
    this.manufacturerService
      .getManufacturerTimeLine(this.id, refresh)
      .subscribe((result) => {
        if (result) {
          this.userfbTimeLineList = result;
          this.userfbTimeLineList.forEach(s =>
            s.eventTs = moment(s.eventTs).format('DD-MM-YYYY')
          )
        }
      });
  }
}
